import {useEffect,useRef} from "react";

/*************
 * useInterval runs the latest callback every delay milliseconds and clears
 * the timer on unmount or when the delay changes.
 */
export function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    const id = setInterval(() => savedCallback.current(), delay);
    return () => clearInterval(id);
  }, [delay]);
}

/*************
 * usePrevious is a hook that returns the previous value of
 * any given variable.
 */
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}